module.exports = __webpack_public_path__ + "static/media/diamonds_8.fe7a27bf.png";